export const config = {
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:3000",
  stripePublicKey: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY || "",
  currency: process.env.NEXT_PUBLIC_CURRENCY || "usd",
  paymentsUrl: process.env.NEXT_PUBLIC_PAYMENTS_URL || "http://localhost:5001",
  dashboardUrl: process.env.NEXT_PUBLIC_DASHBOARD_URL || "http://localhost:5000",
};